if (!customElements.get('ff-cut-summary')) {
    class FFCutSummary extends HTMLElement {
      connectedCallback() {
        this.updateSummary = (options) => {
          const size = String(options[Number(this.dataset.sizeIndex)] || '');
          const color = String(options[Number(this.dataset.colorIndex)] || '');
          const cut = this.querySelector('[data-summary-cut]');
          const colorValue = this.querySelector('[data-summary-color]');
          const length = size.match(/(\d+(?:\.\d+)?)\s*cm\b/i);
          if (cut) cut.textContent = length
            ? length[1] + (this.dataset.width ? ' × ' + this.dataset.width : '') + ' cm'
            : size || this.dataset.prompt;
          if (colorValue) colorValue.textContent = color
            ? (/^\d+(?:\s|\(|$)/.test(color) ? this.dataset.colorPrefix + ' ' : '') + color
            : this.dataset.prompt;
        };
        this.onVariantChange = (event) => this.updateSummary(event.detail?.variant?.options || []);
        this.onOptionChange = (event) => {
          if (event && !event.target.closest('hdt-variant-picker')) return;
          this.variantPicker = this.closest('.hdt-group-product-block')?.querySelector('hdt-variant-picker');
          const options = [];
          this.variantPicker?.querySelectorAll('fieldset[data-index]').forEach((fieldset) => {
            const selected = fieldset.querySelector('input:checked, input[is-value], select');
            options[Number(fieldset.dataset.index)] = selected?.value || '';
          });
          this.updateSummary(options);
        };
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.variantForm = document.getElementById(this.dataset.form);
          this.variantForm?.addEventListener('variant:change', this.onVariantChange);
          this.variantPicker = this.closest('.hdt-group-product-block')?.querySelector('hdt-variant-picker');
          this.variantGroup = this.closest('.hdt-group-product-block');
          this.variantGroup?.addEventListener('change', this.onOptionChange, true);
          this.onOptionChange();
        });
      }
      disconnectedCallback() {
        this.variantForm?.removeEventListener('variant:change', this.onVariantChange);
        this.variantGroup?.removeEventListener('change', this.onOptionChange, true);
      }
    }
    customElements.define('ff-cut-summary', FFCutSummary);
  }
